import React from "react"
import Link from "../components/Link"

import MenuButton from "../../static/svg/menu.svg"

const CustomMenuButton = ({ onPress }) => {
  return (
    <div role="button" onClick={onPress}>
      <MenuButton className="menu-button-icon" />
    </div>
  )
}

const Menu = () => {
  const handleEvent = () => {
    const element = document.getElementById("nav-modal")
    element.classList.add("is-visible")
  }

  return (
    <React.Fragment>
      <ul className="menu">
        <li>
          <Link to="/patientguide/">Patient Guide</Link>
        </li>
        <li>
          <Link to="/unternehmen/">Unternehmen</Link>
        </li>
        <li>
          <Link to="/mediathek/">Mediathek</Link>
        </li>
        <li>
          <Link to="/blog/">Nachrichten</Link>
        </li>
        <li>
          <Link to="/termine/">Termine</Link>
        </li>
        <li>
          <Link to="/partner/">Partner</Link>
        </li>
        <li>
          <Link to="/khzg/">KHZG</Link>
        </li>
        <li>
          <Link to="/team/">Team</Link>
        </li>
      </ul>
      <div className="menu_mobile" role="button">
        <CustomMenuButton onPress={handleEvent} />
      </div>
    </React.Fragment>
  )
}

export default Menu
